import { createRouter, createWebHistory } from 'vue-router';

import Home from '@/views/User/Home';
import Profile from '@/views/User/Profile';
import UpdateProfile from '@/views/User/UpdateProfile';
import ChangePassword from '@/views/User/ChangePassword';
import Experience from '@/views/User/Experience';
import ProjectDetail from '@/views/User/ProjectDetail';
import Followers from '@/views/User/Followers';
import Projects from '@/views/User/Projects';
import PostDetail from '@/views/User/PostDetail';
import Message from '@/views/User/Message';
import PlanDetail from '@/views/User/PlanDetail';
import ServiceRequests from '@/views/User/ServiceRequests';
import ServiceDetail from '@/views/User/ServiceDetail';
import UserBlog from '@/views/User/UserBlog';
import NotificationSetting from '@/views/User/NotificationSetting';
import PlanCategoryDetail from '@/views/User/PlanCategoryDetail';
import ProjectCategoryDetail from '@/views/User/ProjectCategoryDetail';
import PostCategoryDetail from '@/views/User/PostCategoryDetail';

import CompanyDetail from '@/views/CompanyDetail';
import RegisterCompany from '@/views/User/RegisterCompany';
import MyCompanies from '@/views/User/MyCompanies';
import Search from '@/views/User/Search';
import Blog from '@/views/Blog';
import BlogDetail from '@/views/BlogDetail';
import BlogCategory from '@/views/BlogCategory';
import BlogSearch from '@/views/BlogSearch';
import Terms from '@/views/Terms';
import PrivacyPolicy from '@/views/PrivacyPolicy';
import Services from '@/views/Services';
import not_found from '@/views/404';

import Login from '@/views/Auth/Login';
import Register from '@/views/Auth/Register';
import ForgotPassword from '@/views/Auth/ForgotPassword';
import ResetPassword from '@/views/Auth/ResetPassword';
import VerifyAccount from '@/views/Auth/VerifyAccount';
import Index from '@/views/Index';
import Contact from '@/views/Contact';
import MarketPlace from '@/views/Shop/Products';
import Listings from '@/views/Listings';
import ListingDetail from '@/views/ListingDetail';

const routes = [
  // Landing page (guests see this at /)
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: { title: 'Welcome to Structurecity - Listings, services, marketplace, news' },
  },

  // Auth-required routes
  {
    path: '/listing',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true, title: 'Structurecity | Listings' },
  },
  {
    path: '/feeds',
    name: 'Feed',
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: '/profile/update',
    name: 'UpdateProfile',
    component: UpdateProfile,
    meta: { requiresAuth: true, title: 'Structurecity | Update Account' },
  },
  {
    path: '/notification-settings',
    name: 'NotificationSetting',
    component: NotificationSetting,
    meta: { requiresAuth: true, title: 'Structurecity | Notification Setting' },
  },
  {
    path: '/profile/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: { requiresAuth: true, title: 'Structurecity | Change Password' },
  },
  {
    path: '/profile/experience',
    name: 'Experience',
    component: Experience,
    meta: { requiresAuth: true },
  },
  {
    path: '/messages',
    name: 'messages',
    component: Message,
    meta: { requiresAuth: true, title: 'Structurecity | Messages' },
  },
  {
    path: '/my-followers',
    name: 'Followers',
    component: Followers,
    meta: { requiresAuth: true, title: 'Structurecity | Followers' },
  },
  {
    path: '/my-Projects',
    name: 'Projects',
    component: Projects,
    meta: { requiresAuth: true, title: 'Structurecity | My Projects' },
  },
  {
    path: '/my-blog-history',
    name: 'UserBlog',
    component: UserBlog,
    meta: { requiresAuth: true, title: 'Structurecity | My Blog History' },
  },
  {
    path: '/my-service-requests',
    name: 'ServiceRequests',
    component: ServiceRequests,
    meta: { requiresAuth: true, title: 'Structurecity | My Service Requests' },
  },

  // Guest-only routes (redirect if already authenticated)
  {
    path: '/sign-in',
    name: 'Login',
    component: Login,
    meta: { guestOnly: true, title: 'Structurecity | Sign In' },
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { guestOnly: true, title: 'Structurecity | Register' },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { guestOnly: true, title: 'Structurecity | Forgot Password' },
  },

  // Public routes
  {
    path: '/sc/profile/:id',
    name: 'Profile',
    component: Profile,
  },
  {
    path: '/project/:id',
    name: 'ProjectDetail',
    component: ProjectDetail,
  },
  {
    path: '/post/:id',
    name: 'PostDetail',
    component: PostDetail,
  },
  {
    path: '/plan/:id',
    name: 'PlanDetail',
    component: PlanDetail,
  },
  {
    path: '/project/category/:id',
    name: 'ProjectCategoryDetail',
    component: ProjectCategoryDetail,
  },
  {
    path: '/post/category/:id',
    name: 'PostCategoryDetail',
    component: PostCategoryDetail,
  },
  {
    path: '/plan/category/:id',
    name: 'PlanCategoryDetail',
    component: PlanCategoryDetail,
  },
  {
    path: '/company/:id',
    name: 'CompanyDetail',
    component: CompanyDetail,
  },
  {
    path: '/my-companies',
    name: 'MyCompanies',
    component: MyCompanies,
    meta: { requiresAuth: true, title: 'Structurecity | My Companies' },
  },
  {
    path: '/register-company',
    name: 'RegisterCompany',
    component: RegisterCompany,
    meta: { title: 'Structurecity | Register Company' },
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    meta: { title: 'Structurecity | Search' },
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog,
    meta: { title: 'Structurecity | Blog' },
  },
  {
    path: '/blog/:id',
    name: 'BlogDetail',
    component: BlogDetail,
  },
  {
    path: '/blog/category/:id',
    name: 'BlogCategory',
    component: BlogCategory,
  },
  {
    path: '/blog-search',
    name: 'BlogSearch',
    component: BlogSearch,
    meta: { title: 'Structurecity | Search Blog' },
  },
  {
    path: '/terms-and-conditions',
    name: 'Terms',
    component: Terms,
    meta: { title: 'Structurecity | Terms and Conditions' },
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: { title: 'Structurecity | Privacy Policy' },
  },
  {
    path: '/services',
    name: 'Services',
    component: Services,
    meta: { title: 'Structurecity | Services' },
  },
  {
    path: '/service/:id',
    name: 'ServiceDetail',
    component: ServiceDetail,
  },
  {
    path: '/reset-password/:id',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { title: 'Structurecity | Reset Password' },
  },
  {
    path: '/verify/account/:id',
    name: 'VerifyAccount',
    component: VerifyAccount,
    meta: { title: 'Structurecity | Verify Account' },
  },
  {
    path: '/listings',
    name: 'Listings',
    component: Listings,
    meta: { title: 'Structurecity | Browse Listings' },
  },
  {
    path: '/listing/:type/:slug',
    name: 'ListingDetail',
    component: ListingDetail,
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue'),
    meta: { title: 'Structurecity | About' },
  },
  {
    path: '/contact',
    name: 'Contact Us',
    component: Contact,
    meta: { title: 'Structurecity | Contact Us' },
  },
  {
    path: '/shop',
    name: 'shop',
    component: MarketPlace,
    meta: { title: 'Structurecity | Marketplace' },
  },
  {
    path: '/auth/:provider/callback',
    component: { template: '<div class="auth-component"></div>' },
  },
  {
    path: '/404',
    name: '404',
    component: not_found,
    meta: { title: 'Structurecity | Page not found' },
  },
  {
    path: '/:pathMatch(.*)*',
    component: not_found,
    meta: { title: 'Structurecity | Page not found' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) document.title = to.meta.title;

  const isAuthenticated = !!localStorage.getItem('user');

  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'Login' });
  } else if (to.meta.guestOnly && isAuthenticated) {
    next({ name: 'Home' });
  } else if (to.path === '/' && isAuthenticated) {
    next({ name: 'Home' });
  } else {
    next();
  }
});

export default router;
